<script>
import { getReportBwVersionApi, getReportPublishVersionApi } from "@/api/report";
import { getUserInfo } from "@/api/index";

const config = {
    preview: {
        title: "请选择要查看的报告期间",
        content: ""
    },
    new: {
        title: "确认要新建/覆盖本期报告吗？",
        content: "本期报告期间为 {month} ，如本期报告数据已存在，原先修改将被覆盖。"
    },
    edit: {
        title: "请选择要编辑的报告期间",
        content: ""
    },
    origin: {
        title: "请选择要查看的报告期间",
        content: ""
    }
};

export default {
    name: "reportPrevious",
    methods: {
        //获取展示按钮的权限  只有风控部的人可以看到所有按钮 其他role只能看往期发布报告
        getAuthInfo(){
            getUserInfo().then((res) => {
            if (res.code == 200) {
                 this.userInfoJson = res.data
                
            }
      });
        },
        showDialog(type) {
            this.dialogType = type;
            this.dialogVisible = true;

            if (type === "new") {
                const today = new Date();
                const date = today.getDate();
                const month = today.getMonth() + 1;
                const year = today.getFullYear();
                this.options = [];
                for (let i = 2; i <= month - (date <= 15 ? 2 : 1); i++) {
                    const value = `${year}${i < 10 ? `0${i}` : i}`;
                    this.options.push({
                        value: value,
                        label: this.formatMonth(`${value.slice(0, 4)}.${value.slice(4, 6)}`)
                    });
                }
            } else if (type === "preview") {
                this.options = this.options2.map(t => {
                    return {
                        value: t.dataversion,
                        label: this.formatMonth(`${t.dataversion.slice(0, 4)}.${t.dataversion.slice(4, 6)}`)
                    };
                });
            } else {
                this.options = this.options1.map(t => {
                    return {
                        value: t.dateVersion,
                        label: this.formatMonth(`${t.dateVersion.slice(0, 4)}.${t.dateVersion.slice(4, 6)}`)
                    };
                });
            }
            this.month = this.options.at(-1)?.value;
        },
        async setContent() {
            if (this.dialogType !== "new") {
                this.content = "";
                return;
            }
            // 获取BW version
            const data1 = await getReportBwVersionApi();
            const find = data1?.data?.find(t => t.dateVersion === this.month)
            if (find) {
                this.content = find.info
            } else {
                this.content = `本期报告期间为${this.month.slice(0, 4)}.${this.month.slice(4, 6)}，本期报告不存在修改编辑版本，将新建本期报告。`

            }

        },
        handleClose() {
            this.dialogVisible = false;
        },
        handleConfirm() {
            const loading = this.$loading({
                lock: true,
                text: "数据加载中",
                background: "rgba(0, 0, 0, 0.7)"
            });
            loading.close();
            switch (this.dialogType) {
                case "preview":
                    this.$router.push("/report/preview?month=" + this.month);
                    break;
                case "new":
                    this.$router.push("/report/new?month=" + this.month);
                    break;
                case "edit":
                    this.$router.push("/report/edit?month=" + this.month);
                    break;
                case "origin":
                    // const { origin, pathname } = location
                    // window.open(`${origin}${pathname}#report/origin?month=${this.month}`)
                    this.$router.push("/report/origin?month=" + this.month);
                    break;
                default:
                    console.log("error", this.dialogType);
            }
            this.$nextTick(() => {
                this.handleClose();
            });
        },
        async getData() {
            const loading = this.$loading({
                lock: true,
                text: "加载中",
                background: "rgba(0, 0, 0, 0.65)"
            });
            try {
                // 获取BW version
                const data1 = await getReportBwVersionApi();
                if (data1.code == 200) {
                    this.options1 = data1.data || [];
                }
                // 获取发布version
                const data2 = await getReportPublishVersionApi();
                if (data2.code == 200) {
                    this.options2 = data2.data || [];
                }
            } finally {
                loading.close();
            }
        },
        formatMonth(date, day = false) {
            date = new Date(date);
            const month = date.getMonth() + 1;
            return `${date.getFullYear()}.${month < 10 ? `0${month}` : month}${day ? `.${date.getDate()}` : ""}`;
        }
    },
    data() {
        return {
            userInfoJson:false,
            dialogVisible: false,
            dialogType: "preview",
            content: "",
            month: "",
            config,
            options2: [],
            options1: [],
            options: []
        };
    },
    created() {
        this.getAuthInfo()
        this.getData();
    },
    watch: {
        month() {
            this.setContent();
        }
    }
};
</script>

<template>
    <div class="report-previous">
        <div class="report-header">
            <span>风控报告</span>
        </div>
        <div class="btns">
            <div class="btn" @click="showDialog('preview')" v-if="userInfoJson">查看往期报告</div>
            <div class="btn" @click="showDialog('new')" v-if="userInfoJson && userInfoJson.roleName == '风控部'">新建/覆盖本期报告</div>
            <div class="btn" @click="showDialog('edit')" v-if="userInfoJson && userInfoJson.roleName == '风控部'">编辑本期报告</div>
            <div class="btn" @click="showDialog('origin')" v-if="userInfoJson && userInfoJson.roleName == '风控部'">查看初始版本报告</div>
        </div>
        <el-dialog
            :title="config[dialogType].title"
            :visible.sync="dialogVisible"
            width="400px"
            :before-close="handleClose">
            <el-select v-model="month" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
            </el-select>
            <p style="margin-top: 20px">
                <span v-if="content">{{ content }}</span>
            </p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" size="small">取 消</el-button>
                <el-button type="primary" @click="handleConfirm" size="small">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<style scoped lang="less">
.report-previous {
    height: 100vh;
    background-color: #fff;

    .report-header {
        background-color: rgb(39, 49, 59);
        margin-bottom: 20px;
        text-align: center;
        color: #fff;
        font-size: 24px;
        line-height: 60px;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 10;
    }

    .btns {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);

        .btn {
            cursor: pointer;
            width: 392px;
            height: 70px;
            line-height: 70px;
            background-color: rgba(191, 157, 99, 1);
            color: rgba(255, 255, 255, 1);
            border-radius: 4px;
            font-size: 20px;
            text-align: center;
        }

        .btn + .btn {
            margin-top: 58px;
        }
    }
}
</style>